import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import { useNavigate } from 'react-router-dom';
import Pagination from '../components/Pagination';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../components/Navigation';
import { Loader } from '../components/ModalsCommonFunctions';

const QuestionTypeMaster = () => {
    const authorizedAxios = generateAxiosInstance()
    const [questionTypeName, setQuestionTypeName] = useState('')
    const [questionTypes, setQuestionTypes] = useState([])
    const [editId, setEditId] = useState(null)

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);
    const [refresh, setRefresh] = useState(true);

    const [nameSort, setNameSort] = useState(null);
    const [dateSort, setDateSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["questionTypeName", "createdAt"];

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('')
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            setRefresh(!refresh);
        }
    }, [searchValue]);


    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            setCurrPage(1);
            setQuestionTypes(await searchArray("A", '/get-question-type-master', searchKeys, searchValue.trim()))
        }
    }

    useEffect(() => {
        const apiUrl = `/get-question-type-master`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setQuestionTypes(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }, [refresh]);

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(questionTypes, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(questionTypes.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > questionTypes.length) {
            endIndex = questionTypes.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(questionTypes.slice(startIndex, endIndex));
    }, [questionTypes, currPage, itemsPerPage]);

    useEffect(() => {
        if (questionTypeName !== '') {
            setError('')
        }
    }, [questionTypeName])

    const addQuestionType = () => {
        const apiUrl = `/add-question-type-master`;

        if (questionTypeName !== "") {
            setLoading(true);
            authorizedAxios && authorizedAxios.post(apiUrl, {
                questionTypeName,
            })
                .then(response => {
                    setQuestionTypes((prevQuestionTypes) => [...prevQuestionTypes, response.data.result]);
                    setQuestionTypeName('')
                    setRefresh(!refresh);
                    setSaveId(response.data.result.id);
                    setNameSort(null);
                    setDateSort(null);
                    setSearchValue(null);
                    Swal.fire(
                        { text: response.data.message }
                    );
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        } else {
            setError("This field is required.")
        }
    }

    const deleteQuestionType = (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            setLoading(true);
            const apiUrl = `/delete-question-type-master?id=${id}`;
            authorizedAxios && authorizedAxios.delete(apiUrl)
                .then(response => {
                    const page = deleteItem(currPage, itemsPerPage, questionTypes.length);
                    setRefresh(!refresh);
                    setCurrPage(page);

                    Swal.fire(
                        { text: response.data.message }
                    );
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        }
    }

    const updateQuestionType = () => {
        setLoading(true);
        const apiUrl = `/edit-question-type-master?id=${editId}`;
        authorizedAxios && authorizedAxios.put(apiUrl, {
            questionTypeName,
        })
            .then(response => {
                setQuestionTypes((prevQuestionTypes) => [...prevQuestionTypes].map((questionType) => questionType.id == editId ? response.data.result : questionType));
                setEditId(null);
                setQuestionTypeName('')
                Swal.fire(
                    { text: response.data.message }
                );
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            })
            .finally(() => {
                setLoading(false); // End loading
            });
    }

    useEffect(() => {
        if (nameSort == true || nameSort == false) {
            setDateSort(null);
        }
    }, [nameSort])

    useEffect(() => {
        if (dateSort == true || dateSort == false) {
            setNameSort(null);
        }
    }, [dateSort])

    const handleInputReset = () => {
        setQuestionTypeName('');
        setEditId('');
        setNameSort(null);
        setDateSort(null);
        setError("");
    }

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <div id='scroll-up'></div>
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Question Type Master</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-list"></i> Question Type Master</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">

                                                <div className="col-md-12 board_name">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Enter Question Type Name</label>
                                                    <input type="text" className="form-control" id="gradeName" value={questionTypeName} onChange={(e) => setQuestionTypeName(e.target.value.toUpperCase())} />
                                                    {error && <p style={{ color: 'red' }}>{error}</p>}
                                                </div>

                                                <div className="col-md-12 mt-3 d-flex justify-content-center button-container">
                                                    {!editId && <button className="btn btn-primary" type="button" onClick={addQuestionType}>Save</button>}
                                                    <button className="btn btn-danger delete_icon delete_icon" type="button" onClick={handleInputReset}>Reset</button>
                                                    {
                                                        editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateQuestionType} disabled={!editId}>Update</button>)
                                                    }
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>

                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col">Sr. No.</th>
                                                                        <th scope="col">
                                                                            Question Type Name
                                                                            <SortIcon sortState={nameSort} setSortState={setNameSort} setData={setQuestionTypes} setCurrPage={setCurrPage} sortingPath={"questionTypeName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Date
                                                                            <SortIcon sortState={dateSort} setSortState={setDateSort} setData={setQuestionTypes} setCurrPage={setCurrPage} sortingPath={"createdAt"} />
                                                                        </th>
                                                                        <th scope="col">Action</th>

                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData.length > 0 ?
                                                                            displayedData.map((questionType, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row">{startIndex + index + 1}</th>
                                                                                        <td>{questionType.questionTypeName}</td>
                                                                                        <td>{questionType.createdAt.split(",")[0]}</td>
                                                                                        <td>
                                                                                            <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => {
                                                                                                setQuestionTypeName(questionType.questionTypeName);
                                                                                                setEditId(questionType.id);
                                                                                                document.getElementById('scroll-up').scrollIntoView({ behavior: 'smooth' });
                                                                                            }}><i class="fa-light fa-pen-to-square"></i></button>
                                                                                            <button className="btn btn-outline-danger delete_icon" type="button" disabled={editId === questionType.id} onClick={() => deleteQuestionType(questionType.id)}> <i class="fa-light fa-trash-can"></i></button>

                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Question Types Available</th>

                                                                            </tr>)
                                                                    }

                                                                </tbody>
                                                            </table>

                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={questionTypes.length} />

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default QuestionTypeMaster;